import React from 'react';

import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { useCommands } from '@remirror/react-core';

import '../../styles.css';

export const Heading: React.FC<{ currentHeadingLevel: number }> = ({
  currentHeadingLevel
}) => {
  const { toggleHeading } = useCommands();

  return (
    <FormControl
      sx={{ padding: '0px', height: '36px' }}
      className="text-level-select"
    >
      <Select<number>
        sx={{
          lineHeight: '16px',
          minHeight: '36px',
          height: '36px',
          padding: '10px'
        }}
        value={Number(currentHeadingLevel)}
        onChange={(event: SelectChangeEvent<number>) => {
          if (event.target.value === 0) {
            toggleHeading({ level: Number(currentHeadingLevel) });
          } else {
            toggleHeading({ level: Number(event.target.value) });
          }
        }}
      >
        <MenuItem value={0}>Paragraph</MenuItem>
        <MenuItem value={1}>H1</MenuItem>
        <MenuItem value={2}>H2</MenuItem>
        <MenuItem value={3}>H3</MenuItem>
        <MenuItem value={4}>H4</MenuItem>
        <MenuItem value={5}>H5</MenuItem>
        <MenuItem value={6}>H6</MenuItem>
      </Select>
    </FormControl>
  );
};
